export default {
    entityKey: 'synthetic-users',
    basePath: '/synthetic-users',
    titles: {
        singular: 'Synthetic User',
        plural: 'Synthetic Users'
    }
}
